// extracted by mini-css-extract-plugin
export default {"component223":"FirstName_component223__CSQJZ","rectangle":"FirstName_rectangle__VIQFi","damola":"FirstName_damola__BAsaW","firstName":"FirstName_firstName__-k9Mw"};